import { useQuery } from 'react-query';

import { getBaseLineDateOption as queryFn } from 'api/endPoints/getBaseLineDateOption';

import { TDefaultBaseLinePerVersion } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProjectPreferences/ProjectPreferences.utils';

export const useQueryGetBaseLineDateOption = ({ projectId }) => {
    return useQuery<TDefaultBaseLinePerVersion, QueryError>(
        ['useQueryGetBaseLineDateOption', projectId],
        () => queryFn(projectId),
        {
            enabled: Boolean(projectId),
            staleTime: 0,
        },
    );
};
